// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_103a151b99--gallery--ksgVp","image":"_103a151b99--image--JLjxL","gallery--reverse":"_103a151b99--gallery--reverse--THtl_"};